import { injectable } from "inversify";
import { ManagerOptions, Socket, io } from "socket.io-client";
import { Endpoints, SocketEvents } from "../shared/enum";

@injectable()
export class DefaultSocketIOService {
    private serverUrl = Endpoints.SOCKETIO_BASE_URL;
    private socketIoConnection = null;

    constructor() {
        this.openConnection();
    }

    public openConnection() {
        this.socketIoConnection = io(this.serverUrl, {
            path: "/sio",
            withCredentials: true, // Include cookies for authentication
            autoConnect: true,
        } as ManagerOptions).connect();

        console.log("creating socket io connection: ", this.socketIoConnection);

        // Register global error handler for session-based errors
        this.registerGlobalErrorHandler();
    }

    /**
     * Register global error handler for game_error events from backend.
     * Handles session-related errors (e.g., "no save selected" when save_id missing from session).
     */
    private registerGlobalErrorHandler() {
        this.socketIoConnection.on(
            SocketEvents.GAME_ERROR,
            (error: { message: string; code?: string }) => {
                console.error("[SocketIO] Game error received:", error);

                // If backend reports "no save selected", it means the session lost the save_id
                // This can happen on reconnection or session expiry
                if (
                    error.message?.includes("no save selected") ||
                    error.code === "NO_SAVE_SELECTED"
                ) {
                    console.warn(
                        "[SocketIO] Session missing save_id - redirecting to load game screen"
                    );

                    // Emit Phaser event for scenes to handle (e.g., redirect to load screen)
                    // Using window custom event since we don't have Phaser scene reference here
                    window.dispatchEvent(
                        new CustomEvent("game_error:no_save_selected", {
                            detail: error,
                        })
                    );
                }
            }
        );
    }

    public getConnection(): Socket {
        return this.socketIoConnection;
    }

    public close() {
        this.socketIoConnection.disconnect();
    }
}
